function safeGetItemFromLocalStorage(key: string) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSaveItemToLocalStorage(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

export const removeItemFromLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

export function getItemFromLocalStorageAsObject<T>(key: string) {
  const currentStr = safeGetItemFromLocalStorage(key);
  return currentStr ? (JSON.parse(currentStr) as T) : undefined;
}

export function saveItemToLocalStorage(key: string, val: unknown) {
  const stringVal = typeof val === "string" ? val : JSON.stringify(val);
  safeSaveItemToLocalStorage(key, stringVal);
}
